import script from "./Select.vue?vue&type=script&setup=true&lang=ts"
export * from "./Select.vue?vue&type=script&setup=true&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=4230f0be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4230f0be"]])

export default __exports__